import { render } from "./ArrowUp.vue?vue&type=template&id=6fa9fc90"
import script from "./ArrowUp.vue?vue&type=script&lang=js"
export * from "./ArrowUp.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ArrowUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fa9fc90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fa9fc90', __exports__)) {
    api.reload('6fa9fc90', __exports__)
  }
  
  module.hot.accept("./ArrowUp.vue?vue&type=template&id=6fa9fc90", () => {
    api.rerender('6fa9fc90', render)
  })

}


export default __exports__